// extracted by mini-css-extract-plugin
export default {"workflow_content__note":"Workflow_workflow_content__note__5eZXe"};